import { createApi } from '@reduxjs/toolkit/query/react'
import { queryParams } from '../../../Utils'
import { createNeighborhoodAwareBaseQuery } from '../../../Utils/baseQuery'

export const pushnotificationApiService = createApi({
    reducerPath: 'pushnotificationApi',
    baseQuery: createNeighborhoodAwareBaseQuery('/push-notification/'),
    endpoints: (builder) => ({
        getPushNotifications: builder.query({
            query: args => {
                let query = queryParams(args)
                return `get${query}`
            }
        }),
        createPushNotification: builder.mutation({
            query: (body) => ({
                url: `create`,
                method: "POST",
                body
            })
        }),
        deletePushNotification: builder.mutation({
            query: (id) => ({
                url: `delete/${id}`,
                method: "DELETE"
            })
        }),
        resendPushNotification: builder.mutation({
            query: (id) => ({
                url: `resend/${id}`,
                method: "POST"
            })
        })
    })
})

export const {
    useGetPushNotificationsQuery,
    useCreatePushNotificationMutation,
    useDeletePushNotificationMutation,
    useResendPushNotificationMutation
} = pushnotificationApiService
